import i18n from '@/plugins/i18n';
import { notification } from 'ant-design-vue';

const [api, contextHolder] = notification.useNotification();

export { contextHolder };
export function notificationSucess(
  description,
  heading = i18n.global.t('success'),
  duration = 6,
  placement = 'topRight',
) {
  return api.success({
    message: heading,
    description,
    duration,
    placement,
  });
}
export function notificationError(
  description,
  heading = i18n.global.t('error'),
  duration = 6,
  placement = 'topRight',
) {
  return api.error({
    message: heading,
    description,
    duration,
    placement,
  });
}
